import React, { useContext, useEffect, useState } from 'react'
import AdminContext from '../../StateContext/Application'
import { useLanguage } from '../../../../lang/langcontext/LanguageContext'
const ProposalList = () => {
    const { language, toggleLanguage, t } = useLanguage();
    const context = useContext(AdminContext)
    const { GetProposallist } = context
    const [proposallist, setProposalList] = useState([])
    const [searchTerm, setSearchTerm] = useState('');
    const budgetEstimation = proposallist;
    const [filteredBills, setFilteredBills] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const billsPerPage = 10;
    const [selectedYear, setSelectedYear] = useState('');
    const [selectedTaluka, setSelectedTaluka] = useState('');

    const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
    const indexOfLastBill = currentPage * billsPerPage;
    const indexOfFirstBill = indexOfLastBill - billsPerPage;
    const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

    const proposalEstimate = async () => {
        let data = await GetProposallist()
        setProposalList(data)
    }

    useEffect(() => {
        proposalEstimate()
    }, [])
   useEffect(() => {
        const lowerSearchTerm = searchTerm.toLowerCase();
        let filtered = proposallist.filter(bill =>
            Object.values(bill).some((val) =>
                (val || '').toString().toLowerCase().includes(lowerSearchTerm)
            )
        );
        if (selectedYear) {
            filtered = filtered.filter(bill => bill.Proposal_year === selectedYear);
        }
        if (selectedTaluka) {
            filtered = filtered.filter(bill => bill.Taluka === selectedTaluka);
        }

        setFilteredBills(filtered);
    }, [searchTerm, proposallist, selectedYear, selectedTaluka]);
    const years = [...new Set(proposallist.map(proposal => proposal.Proposal_year))];
    const talukas = [...new Set(proposallist.filter(proposal => proposal.Proposal_year === selectedYear).map(proposal => proposal.Taluka))];

    // return (
    //     <div style={{ overflowX: "hidden", display: 'grid', justifyContent: 'center', padding: "20px 0px" }}>
    //         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "78vw", marginBottom: "15px" }}>
    //             <h4 style={{ margin: "10px" }}>Proposal List</h4>
    //             <input type="text" placeholder="Search" onChange={(e) => setSearchTerm(e.target.value)} value={searchTerm} style={{ width: "250px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue', fontSize: "14px", marginRight: "10px" }} />
    //         </div>
    //         <div className='mx-5 my-2'style={{gap:'10px'}}>
    //              <select 
    //                 value={selectedYear} 
    //                 onChange={(e) => setSelectedYear(e.target.value)} 
    //                 style={{ padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue' }}
    //             >
    //                 <option value="">All Years</option>
    //                 {years.map(year => (
    //                     <option key={year} value={year}>{year}</option>
    //                 ))}
    //             </select>
    //             <select 
    //                 value={selectedTaluka} 
    //                 onChange={(e) => setSelectedTaluka(e.target.value)} 
    //                 style={{ padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue' }}
    //                 disabled={!selectedYear} 
    //             >
    //                 <option value="">All Talukas</option>
    //                 {talukas.map(taluka => (
    //                     <option key={taluka} value={taluka}>{taluka}</option>
    //                 ))}
    //             </select>
    //         </div>
    //         <div style={{ display: "grid", justifyContent: "center", width: "80vw", maxWidth: "100%", }}>
    //             <div style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', display: 'flex', width: '75vw', overflowX: "auto", border: '1px solid #3b409e' }}>
    //                 <table style={{ width: '100%', width: "100%", borderCollapse: "collapse", minWidth: "1200px", }}>
    //                     <thead style={{ borderTop: 'none' }}>
    //                         <tr style={{ color: 'white', border: 'none', overflow: 'hidden', height: '3.5rem' }}>
    //                             <th>Sr.No</th>
    //                             <th>Proposal ID</th>
    //                             <th>Head Code</th>
    //                             <th>Year</th>
    //                             <th>Taluka</th>
    //                             <th>Constituency</th>
    //                             <th>Gram Panchayat</th>
    //                             <th>Work Name</th>
    //                             <th>File Number</th>
    //                             <th>Amount</th>
    //                             <th>Proposal Copy</th>
    //                             <th>Supplement Doc</th>
    //                             <th>Created At</th>
    //                             <th>GR Assigned</th>
    //                         </tr>
    //                     </thead>
    //                     {
    //                         currentBills?.map((proposal, index) => {
    //                             const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
    //                             return (
    //                                 <tbody>
    //                                     <tr style={{ borderBottom: '1px solid #3b409e', backgroundColor: bgColor, }}>
    //                                         <td>{indexOfFirstBill + index + 1}</td>
    //                                         <td>{proposal.ProposalID}</td>
    //                                         <td>{proposal.HeadCode}</td>
    //                                         <td>{proposal.Proposal_year}</td>
    //                                         <td>{proposal.Taluka}</td>
    //                                         <td>{proposal.Constituency_name}</td>
    //                                         <td>{proposal.Gram_panchayat}</td>
    //                                         <td>{proposal.Work_name}</td>
    //                                         <td>{proposal.Proposal_fileNumber}</td>
    //                                         <td>{proposal.Proposal_amount}</td>
    //                                         <td>
    //                                             {proposal.Proposal_copy ? (
    //                                                 <a href={`/uploads/${proposal.Proposal_copy}`} target="_blank" rel="noreferrer">View</a>
    //                                             ) : 'N/A'}
    //                                         </td>
    //                                         <td>
    //                                             {proposal.Additional_suppDoc ? (
    //                                                 <a href={`/uploads/${proposal.Additional_suppDoc}`} target="_blank" rel="noreferrer">View</a>
    //                                             ) : 'N/A'}
    //                                         </td>
    //                                         <td>{new Date(proposal.created_at).toLocaleString()}</td>
    //                                         <td>{proposal.GRAssigned === 'true' ? 'Yes' : 'No'}</td>
    //                                     </tr>
    //                                 </tbody>
    //                             )
    //                         })
    //                     }
    //                 </table>
    //             </div>
    //         </div>
    //         <div style={{ display: 'flex', justifyContent: 'space-between', padding: ' 0px 2.5rem', height: '3rem', alignItems: 'center' }}>
    //             <div>
    //                 <p>Showing {currentBills?.length} of {proposallist?.length} entries</p>

    //             </div>
    //             <div style={{ display: 'flex', alignItems: 'center' }}>
    //                 {/* First Page Button */}
    //                 <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
    //                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0 }}>
    //                     &laquo;
    //                 </button>
    //                 {/* Previous Button */}
    //                 <button
    //                     onClick={() => setCurrentPage(currentPage - 1)}
    //                     disabled={currentPage === 1}
    //                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
    //                     &lt;
    //                 </button>

    //                 <button
    //                     style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '24px', width: '3rem', margin: 0, borderRadius: 0, border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
    //                 </button>
    //                 {/* Next Button */}
    //                 <button
    //                     onClick={() => setCurrentPage(currentPage + 1)}
    //                     disabled={currentPage === totalPages}
    //                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
    //                     &gt;
    //                 </button>
    //                 {/* Last Page Button */}
    //                 <button
    //                     onClick={() => setCurrentPage(totalPages)}
    //                     disabled={currentPage === totalPages}
    //                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
    //                     &raquo;
    //                 </button>
    //             </div>

    //         </div>
    //     </div>
    // )
     return (
        <div style={{ overflowX: "hidden", display: 'grid', justifyContent: 'center', padding: "20px 0px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "78vw", marginBottom: "15px" }}>
                <h4 style={{ margin: "10px" }}>{t("Proposal List")}</h4>
                <input type="text" placeholder="Search" onChange={(e) => setSearchTerm(e.target.value)} value={searchTerm} style={{ width: "250px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue', fontSize: "14px", marginRight: "10px" }} />
            </div>
            <div className='mx-5 my-2'style={{gap:'10px'}}>
                 <select 
                    value={selectedYear} 
                    onChange={(e) => setSelectedYear(e.target.value)} 
                    style={{ padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue' }}
                >
                    <option value="">{t("All Years")}</option>
                    {years.map(year => (
                        <option key={year} value={year}>{year}</option>
                    ))}
                </select>
                <select 
                    value={selectedTaluka} 
                    onChange={(e) => setSelectedTaluka(e.target.value)} 
                    style={{ padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue' }}
                    disabled={!selectedYear} 
                >
                    <option value="">All Talukas</option>
                    {talukas.map(taluka => (
                        <option key={taluka} value={taluka}>{taluka}</option>
                    ))}
                </select>
            </div>
            <div style={{ display: "grid", justifyContent: "center", width: "80vw", maxWidth: "100%", }}>
                <div style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', display: 'flex', width: '75vw', overflowX: "auto", border: '1px solid #3b409e' }}>
                    <table style={{ width: '100%', width: "100%", borderCollapse: "collapse", minWidth: "1200px", }}>
                        <thead style={{ borderTop: 'none' }}>
                            <tr style={{ color: 'white', border: 'none', overflow: 'hidden', height: '3.5rem' }}>
                                <th>{t("Sr.No")}</th>
                                <th>{t("Proposal ID")}</th>
                                <th>{t("Head Code")}</th>
                                <th>{t("Year")}</th>
                                <th>{t("Taluka")}</th>
                                <th>{t("Constituency")}</th>
                                <th>{t("Gram Panchayat")}</th>
                                <th>{t("Work Name")}</th>
                                <th>{t("File Number")}</th>
                                <th>{t("Amount")}</th>
                                <th>{t("Proposal Copy")}</th>
                                <th>{t("Supplement Doc")}</th>
                                <th>{t("Created At")}</th>
                                <th>{t("GR Assigned")}</th>
                            </tr>
                        </thead>
                        {
                            currentBills?.map((proposal, index) => {
                                const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                return (
                                    <tbody>
                                        <tr style={{ borderBottom: '1px solid #3b409e', backgroundColor: bgColor, }}>
                                            <td>{indexOfFirstBill + index + 1}</td>
                                            <td>{proposal.ProposalID}</td>
                                            <td>{proposal.HeadCode}</td>
                                            <td>{proposal.Proposal_year}</td>
                                            <td>{proposal.Taluka}</td>
                                            <td>{proposal.Constituency_name}</td>
                                            <td>{proposal.Gram_panchayat}</td>
                                            <td>{proposal.Work_name}</td>
                                            <td>{proposal.Proposal_fileNumber}</td>
                                            <td>{proposal.Proposal_amount}</td>
                                            <td>
                                                {proposal.Proposal_copy ? (
                                                    <a href={`/uploads/${proposal.Proposal_copy}`} target="_blank" rel="noreferrer">{t("View")}</a>
                                                ) : 'N/A'}
                                            </td>
                                            <td>
                                                {proposal.Additional_suppDoc ? (
                                                    <a href={`/uploads/${proposal.Additional_suppDoc}`} target="_blank" rel="noreferrer">{t("View")}</a>
                                                ) : 'N/A'}
                                            </td>
                                            <td>{new Date(proposal.created_at).toLocaleString()}</td>
                                            <td>{proposal.GRAssigned === 'true' ? 'Yes' : 'No'}</td>
                                        </tr>
                                    </tbody>
                                )
                            })
                        }
                    </table>
                </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: ' 0px 2.5rem', height: '3rem', alignItems: 'center' }}>
                <div>
                    <p>{t("Showing")} {currentBills?.length} {t("of")} {proposallist?.length} {t("entries")}</p>

                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {/* First Page Button */}
                    <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0 }}>
                        &laquo;
                    </button>
                    {/* Previous Button */}
                    <button
                        onClick={() => setCurrentPage(currentPage - 1)}
                        disabled={currentPage === 1}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                        &lt;
                    </button>

                    <button
                        style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '24px', width: '3rem', margin: 0, borderRadius: 0, border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
                    </button>
                    {/* Next Button */}
                    <button
                        onClick={() => setCurrentPage(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                        &gt;
                    </button>
                    {/* Last Page Button */}
                    <button
                        onClick={() => setCurrentPage(totalPages)}
                        disabled={currentPage === totalPages}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                        &raquo;
                    </button>
                </div>

            </div>
        </div>
    )
}

export default ProposalList
